var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0018 7.99992C10.0018 9.10449 9.10636 9.99992 8.00179 9.99992C6.89722 9.99992 6.00179 9.10449 6.00179 7.99992C6.00179 6.89535 6.89722 5.99992 8.00179 5.99992C9.10636 5.99992 10.0018 6.89535 10.0018 7.99992Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00208 3.33325C5.017 3.33325 2.49014 5.29517 1.64062 7.9999C2.49013 10.7046 5.01699 12.6666 8.0021 12.6666C10.9872 12.6666 13.514 10.7047 14.3636 7.99994C13.5141 5.29519 10.9872 3.33325 8.00208 3.33325Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.5f242a7950cbea00524fed97eedbd377.svg";
export { ForwardRef as ReactComponent };